import { render, staticRenderFns } from "./CopyBtnIcon.vue?vue&type=template&id=0fcf8d0b"
import script from "./CopyBtnIcon.vue?vue&type=script&lang=js"
export * from "./CopyBtnIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports